var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "btnHamburgerWrap d-block d-lg-none" }, [
    _c(
      "button",
      {
        ref: "btn",
        staticClass: "btnHamburger",
        attrs: {
          id: "js_btnHamburger",
          type: "button",
          "aria-controls": "global-nav",
          "aria-expanded": "false",
          "aria-label": "メニューを開閉する",
        },
      },
      [
        _c("span", { ref: "lineTop", staticClass: "btnHamburger_line" }),
        _vm._v(" "),
        _c("span", { ref: "lineMid", staticClass: "btnHamburger_line" }),
        _vm._v(" "),
        _c("span", { ref: "lineBtm", staticClass: "btnHamburger_line" }),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }